export {
  deleteObject,
  getDownloadURL,
  ref,
  uploadString
} from 'firebase/storage'

// Web-specific types - create compatibility layer  
export type FirebaseStorageTypes = {
  Module: any
  Reference: any
}